export default "__VITE_ASSET__CoIqKmKr__"